/* eslint-disable func-names */
/* eslint-disable object-shorthand */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import { formatGivenDate } from '../../../../shared/services/common-functions';
import { uniqueId } from 'lodash';

function onGridReady(params) {
    setTimeout(() => {
        params.api.sizeColumnsToFit();
    }, 500);
}

function checkForAstreik ( params ) {

    if ( ( params.data.reportType === 'Bundle' || params.data.reportType === 'Combo' ) && params.value === params.data.countBundle ) {

        return '*';

    }
    return '';

}

const itemBuildWeekValueGetter = params => {

    const itemBuildWk = formatGivenDate( params.data.itemBuildWk, 'YYYY-MM-DD' );

    if ( itemBuildWk === '' ) return ( <span>{itemBuildWk}</span> );
    if ( itemBuildWk === '2000-01-01' ) {

        return 'Inventory';

    } if ( itemBuildWk === '2000-02-01' ) {

        return 'Rework';

    }
    return itemBuildWk;

};

const orderBuildWeekValueGetter = params => {

    const orderBuildWk = formatGivenDate( params.data.orderBuildWk, 'YYYY-MM-DD' );

    if ( orderBuildWk === '' ) return ( <span>{orderBuildWk}</span> );
    if ( orderBuildWk === '2000-01-01' ) {

        return 'Inventory';

    } if ( orderBuildWk === '2000-02-01' ) {

        return 'Rework';

    }
    return orderBuildWk;

};

const orderBuildWeekValueForDetailGetter = params => {

    const orderBuildWeek = formatGivenDate( params.data.orderBuildWeek, 'YYYY-MM-DD' );

    if ( orderBuildWeek === '' ) return ( <span>{orderBuildWeek}</span> );
    if ( orderBuildWeek === '2000-01-01' ) {

        return 'Inventory';

    } if ( orderBuildWeek === '2000-02-01' ) {

        return 'Rework';

    }
    return orderBuildWeek;

};

const codeBuildWeekValueGetter = params => {

    const codeBuildWk = formatGivenDate( params.data.codeBuildWeek, 'YYYY-MM-DD' );

    if ( codeBuildWk === '' ) return ( <span>{codeBuildWk}</span> );
    if ( codeBuildWk === '2000-01-01' ) {

        return 'Inventory';

    } if ( codeBuildWk === '2000-02-01' ) {

        return 'Rework';

    }
    return codeBuildWk;

};

const colDefs = [

    {
        field: 'family',
        headerName: 'Family',
        sortable: true,
        filter: true,
        width: 100
    },
    {
        field: 'orderingCode',
        headerName: 'Ordering Code',
        sortable: true,
        width: 100,
        cellRenderer: params => {

            if ( params.value === '' ) return ( <span>{params.value}</span> );
            if ( ( params.data.reportType === 'Bundle' || params.data.reportType === 'Combo' ) && ( params.data.orderGroup === 'B' || params.data.orderGroup === 'P' ) ) {

                return ( <span>{checkForAstreik( params )} <Link to={`/${params.data.unitName}/order/availability?constrainttype=BN&constraintkey=${params.value}&week=${formatGivenDate( params.data.itemBuildWk, 'YYYY-MM-DD' )}`}>{params.value}</Link></span> );

            } if ( params.data.orderGroup === 'M' ) {

                return ( <span>{checkForAstreik( params )} <Link to={`/${params.data.unitName}/order/availability?constrainttype=B&constraintkey=${params.value}&week=${formatGivenDate( params.data.itemBuildWk, 'YYYY-MM-DD' )}`}>{params.value}</Link></span> );

            } if ( params.data.orderGroup === 'A' ) {

                return ( <span>{checkForAstreik( params )}{params.value}</span> );

            }
            return ( <span>{checkForAstreik( params )} <Link to={`/${params.data.unitName}/order/availability?constrainttype=${params.data.orderGroup}&constraintkey=${params.value}&week=${formatGivenDate( params.data.itemBuildWk, 'YYYY-MM-DD' )}`}>{params.value}</Link></span> );

        }
    },
    {
        field: 'qnty',
        headerName: 'Qty',
        sortable: true,
        filter: true,
        width: 100,
        cellRenderer: params => {

            if ( params.value === 0 ) return ( <span>{params.value}</span> );
            if ( params.value > 1 ) {

                const linkObject = {
                    pathname: ( `/${params.data.unitName}/constraints/check-orders-order-code` ),
                    key: uniqueId(),
                    search: `?family=${params.data.family.trim()}&orderingcode=${params.data.orderingCode}&orderbuildweek=${formatGivenDate( params.data.orderBuildWk, 'YYYY-MM-DD' )}&dateType=${encodeURIComponent( params.data.selectedDateType )}`
                };
                return ( <Link to={linkObject}>{params.value}</Link> );

            }
            return ( <span>{params.value}</span> );

        }
    },
    {
        field: 'itemBuildWk',
        headerName: 'Item Build Week',
        sortable: true,
        filter: true,
        width: 100,
        valueGetter: itemBuildWeekValueGetter
    },
    {
        field: 'orderBuildWk',
        headerName: 'Order Build Week',
        sortable: true,
        filter: true,
        width: 100,
        valueGetter: orderBuildWeekValueGetter
    },
    {
        field: 'orderNum',
        headerName: 'Order Number',
        sortable: true,
        filter: true,
        width: 100
    },
    {
        field: 'orderGroup',
        headerName: 'Order or Group',
        sortable: true,
        filter: true,
        width: 100
    }
];

export const CheckOrdersOrderDetailTable = props => (

    <section className="atp-search-result-panel check-orders-order-detail-result-panel ">

        <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
            <AgGridReactComponent
                reactNext={true}
                columnDefs={colDefs}
                rowData={props.results}
                onGridReady={onGridReady}
            />
        </div>

    </section>
);

CheckOrdersOrderDetailTable.propTypes = {
    results: PropTypes.array.isRequired
};

const colDefsOrderCodeDetail = [
    {
        field: 'orderingCode',
        headerName: 'Ordering Code',
        sortable: true,
        width: 100,
        cellRenderer: params => {

            if ( params.value === '' ) return ( <span>{params.value}</span> );
            if ( ( params.data.reportType === 'Bundle' || params.data.reportType === 'Combo' ) && ( params.data.orderOrGroup === 'B' || params.data.orderOrGroup === 'P' ) ) {

                return ( <Link to={`/${params.data.unitName}/order/availability?constrainttype=BN&constraintkey=${params.value}&week=${formatGivenDate( params.data.codeBuildWeek, 'YYYY-MM-DD' )}`}>{params.value}</Link> );

            } if ( params.data.orderOrGroup === 'M' ) {

                return ( <Link to={`/${params.data.unitName}/order/availability?constrainttype=B&constraintkey=${params.value}&week=${formatGivenDate( params.data.codeBuildWeek, 'YYYY-MM-DD' )}`}>{params.value}</Link> );

            } if ( params.data.orderOrGroup === 'A' ) {

                return ( <span>{params.value}</span> );

            }
            return ( <Link to={`/${params.data.unitName}/order/availability?constrainttype=${params.data.orderOrGroup}&constraintkey=${params.value}&week=${formatGivenDate( params.data.codeBuildWeek, 'YYYY-MM-DD' )}`}>{params.value}</Link> );

        }
    },
    {
        field: 'codeBuildWeek',
        headerName: 'Code Build Week',
        sortable: true,
        filter: true,
        width: 100,
        valueGetter: codeBuildWeekValueGetter
    },
    {
        field: 'orderBuildWeek',
        headerName: 'Order Build Week',
        sortable: true,
        filter: true,
        width: 100,
        valueGetter: orderBuildWeekValueForDetailGetter
    },
    {
        field: 'orderNumber',
        headerName: 'Order Number',
        sortable: true,
        filter: true,
        width: 100,
        cellRenderer: params => {

            if ( params.value === '' ) {

                return ( <span>{params.value}</span> );

            }
            return ( <Link to={`/${params.data.unitName}/order/information?ordernum=${params.value}`}>{params.value}</Link> );

        }
    },
    {
        field: 'orderOrGroup',
        headerName: 'Order or Group',
        sortable: true,
        filter: true,
        width: 100
    },
    {
        field: 'orderingCodeqty',
        headerName: 'Ordering Code Quantity',
        sortable: true,
        filter: true,
        width: 100
    }
];

export const CheckOrdersOrderCodeDetailTable = props => (

    <section className="atp-search-result-panel check-orders-order-code-detail-result-panel">

        <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
            <AgGridReactComponent
                reactNext={true}
                columnDefs={colDefsOrderCodeDetail}
                rowData={props.results}
                onGridReady={onGridReady}
            />
        </div>

    </section>
);

CheckOrdersOrderCodeDetailTable.propTypes = {
    results: PropTypes.array.isRequired
};
